<template>
    <div>
        <div class="song-list">
            <div class="song-item" v-for="(row, index) in list" :key="row.id">
                <svg-icon v-if="!preview" icon-class="list_move"></svg-icon>
                <div class="number">{{ index + 1 }}</div>
                <div class="name">
                    <el-tooltip :content="row.name" placement="top">
                        <p class="ellipsis">{{ row.name }}</p>
                    </el-tooltip>
                </div>
                <div class="artist">{{ row.showArtist }}</div>
                <div class="file">
                    <el-tooltip :content="row.path ? `${row.name}.${row.format} ` : ''" placement="top">
                        <p class="ellipsis">{{ row.path ? `${row.name}.${row.format} ` : '' }}</p>
                    </el-tooltip>
                </div>
                <div class="operate">
                    <el-tooltip class="item" effect="dark" content="播放" placement="top">
                        <button class="icon-button play" @click.prevent="$player.play(row)"></button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="详情" placement="top">
                        <button class="icon-button look" @click="$refs['track-view-dialog'].show(row)"></button>
                    </el-tooltip>
                    <el-tooltip v-if="!preview" class="item" effect="dark" content="编辑" placement="top">
                        <button class="icon-button edit" @click.prevent="onEdit(row)"></button>
                    </el-tooltip>
                    <el-tooltip v-if="!preview && !isDelete" class="item" effect="dark" content="删除" placement="top">
                        <button class="icon-button delete" @click.prevent="onDelete(row)"></button>
                    </el-tooltip>
                </div>
            </div>
        </div>
        <TrackViewDialog ref="track-view-dialog" :display-lang-code="displayLangCode"></TrackViewDialog>
    </div>
</template>

<script>
import Sortable from 'sortablejs';
import TrackViewDialog from '../TrackViewDialog';
export default {
    components: { TrackViewDialog },
    props: {
        isDelete: {
            type: Boolean,
            default: false
        },
        list: {
            type: Array,
            default: () => []
        },
        preview: {
            type: Boolean,
            default: false
        },
        displayLangCode: {
            type: String,
            default: ''
        }
    },
    data() {
        return {};
    },
    methods: {
        //拖动表格
        drag() {
            this.$nextTick(() => {
                const el = document.querySelectorAll('.song-list')[0];
                Sortable.create(el, {
                    ghostClass: 'sortable-ghost', //拖拽样式
                    animation: 150, // 拖拽延时，效果更好看
                    onEnd: (e) => {
                        // 拖拽结束时的触发
                        let arr = [...this.list]; // 获取表数据
                        arr.splice(e.newIndex, 0, arr.splice(e.oldIndex, 1)[0]); // 数据处理，获取最新的表格数据
                        this.$nextTick(function () {
                            const a1 = this.list.map((a) => a.id).toString();
                            const a2 = arr.map((a) => a.id).toString();
                            if (a1 != a2) {
                                arr.map((item, index) => {
                                    item.sort = index;
                                });
                                this.$emit('onSort', arr);
                            }
                        });
                    },
                });
            });
        },
        onDelete(row) {
            this.$emit('onDelete', row);
        },
        onEdit(row) {
            this.$emit('onEdit', row);
        }
    },
};
</script>
<style lang="scss">
.song-list {
    margin-top: 20px;

    .song-item {
        display: flex;
        height: 120px;
        align-items: center;
        width: 100%;
        background-color: $--color-white;
        padding: 0 30px;
        margin-bottom: 20px;
        border-radius: 10px;

        .svg-icon {
            cursor: pointer;
        }

        .number {
            margin-right: 40px;
            margin-left: 20px;
            width: 20px;
        }

        .name {
            width: 25%;
            font-weight: bold;
        }

        .artist {
            flex: 1;
        }

        .file {
            width: 20%;
        }

        .operate {
            width: 200px;
            text-align: right;
        }

        .icon-button {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            display: inline-block;
            background-color: $--color-grey;
            margin-right: 10px;
            cursor: pointer;
            border: none;
            text-align: center;

            &::after {
                content: "";
                width: 14px;
                height: 14px;
                background-size: cover;
                display: inline-block;
            }

            &.play,
            &.stop,
            &.edit,
            &.look {
                &:hover {
                    background-color: $--color-black;
                }
            }

            &.delete {
                &:hover {
                    background-color: $--color-danger;
                }
            }

            &.play {
                &::after {
                    background: url('~@/assets/img/album/tool_play.svg') center no-repeat;
                }

                &:hover::after {
                    background: url('~@/assets/img/album/tool_play_hover.svg') center no-repeat;
                }
            }

            &.stop {
                &::after {
                    background: url('~@/assets/img/album/tool_stop.svg') center no-repeat;
                }

                &:hover::after {
                    background: url('~@/assets/img/album/tool_stop_hover.svg') center no-repeat;
                }
            }

            &.edit {
                &::after {
                    background: url('~@/assets/img/album/tool_edit.svg') center no-repeat;
                }

                &:hover::after {
                    background: url('~@/assets/img/album/tool_edit_hover.svg') center no-repeat;
                }
            }

            &.delete {
                &::after {
                    background: url('~@/assets/img/album/tool_delete.svg') center no-repeat;
                }

                &:hover::after {
                    background: url('~@/assets/img/album/tool_delete_hover.svg') center no-repeat;
                }
            }

            &.look {
                &::after {
                    background: url('~@/assets/img/album/tool_look.svg') center no-repeat;
                }

                &:hover::after {
                    background: url('~@/assets/img/album/tool_look_hover.svg') center no-repeat;
                }
            }
        }
    }
}
</style>
